import React from 'react';
import { Action, IChatState } from '../../../../interfaces/chat.interface';
import { generatePDFChat } from '../../../../utils/functions';
import './ChatOptions.scss';

// @ts-ignore
import refreshIcon from '../../../../assets/icons/CDA/refresh.svg';
// @ts-ignore
import downloadIcon from '../../../../assets/icons/CDA/download.svg';

interface IProps {
    chatState: IChatState;
    setChatState: React.Dispatch<Action>;
    refOptions: React.MutableRefObject<HTMLDivElement | null>;
}

const ChatOptions = ({ chatState, setChatState, refOptions }: IProps) => {
    const closeChat = () => {
        setChatState({ type: 'TOGGLE_CHAT' });
        setChatState({ type: 'RESET_STATE' });
    };

    const downloadChat = () => {
        generatePDFChat(chatState.chatDataMD);
    };

    return (
        <div className="a-chatOptions" ref={refOptions}>
            <button
                className="a-chatOptions__item"
                onClick={closeChat}
                aria-label="Reinciar chat"
            >
                <img src={refreshIcon} alt="chat icon" />
                Reiniciar Chat
            </button>
            <button
                className="a-chatOptions__item"
                onClick={downloadChat}
                aria-label="Descargar chat"
            >
                <img src={downloadIcon} alt="chat icon" />
                Descargar Chat
            </button>
        </div>
    );
};

export default ChatOptions;
